<template>
  <div class="mt-2">
    <!-- <div :style="[!noInnerWidth ? { width: width } : {}]"> -->
    <div class="table-wrapper">
      <b-table
        :busy="isLoading"
        head-variant="light"
        :no-local-sorting="true"
        :items="items"
        :fields="fields"
        per-page="0"
        :sticky-header="height"
        no-border-collapse
        responsive
        show-empty
        empty-text="Non ci sono informazioni da mostrare"
        small
      >
        <template #table-busy>
          <table-skeleton />
        </template>
        <template #empty>
          <template v-if="newPdfBtn">
            <div
              class="d-flex flex-column justify-content-center align-items-center my-3"
              style="max-width: max-content; margin-inline: auto"
            >
              <p class="mb-2">
                Effettua una ricerca oppure, se non trovi risultati, crea un
                nuovo PDF cliccando sul pulsante qui sotto
              </p>
              <b-button
                class="btn-create px-3"
                type="button"
                variant="primary"
                size="sm"
                @click="onAddNewPdf"
                title="Crea"
                :disabled="!canVerb(resource, 'store')"
                style="max-width: max-content"
              >
                <b-icon icon="plus-circle" aria-hidden="true"></b-icon>
                Crea
              </b-button
              >
            </div>
          </template>
          <template v-else>
            <empty-table
              :isTableInModal="isTableInModal"
              :performedSearch="performedSearch"
              :automaticPerformedSearch="automaticPerformedSearch"
              :filterCount="filterCount"
            />
          </template
          >
        </template>
        <template #cell(actions)="row">
          <div class="action-buttons">
            <b-button
              size="sm"
              variant="lisaweb"
              @click="onEdit(row.item.id, row.item)"
              class="mt-1 mr-1"
              title="Modifica"
            >
              <base-icon name="edit"></base-icon>
            </b-button>
            <b-button
              size="sm"
              variant="lisaweb"
              @click="onDuplicate(row.item)"
              class="mt-1 mr-1"
              title="Duplica"
            >
              <b-icon icon="files"></b-icon>
            </b-button>
            <b-button
              size="sm"
              variant="lisaweb"
              @click="onDestroy(row.item.id)"
              class="mt-1 mr-1"
              title="Elimina"
            >
              <base-icon name="trash"></base-icon>
            </b-button>
          </div>
        </template>
        <template
          v-slot:head(check)="data"
          v-if="hasChecks && !isCheckExclusive && items.length"
        >
          <base-checkbox
            v-model="checkAll"
            name="all"
            class="check"
            @change="onSelectAllRows()"
            ><span v-if="data.label" v-html="data.label"></span>
          </base-checkbox>
        </template>
        <template #cell(header)="{ item }">
          <span v-html="item.header"></span>
        </template>
        <template #cell(body)="{ item }">
          <span v-html="item.body"></span>
        </template>
        <template #cell(ads)="{ item }">
          <span v-html="item.ads"></span>
        </template>
        <template #cell(footer)="{ item }">
          <span v-html="item.footer"></span>
        </template>
        <template #cell(check)="row" v-if="hasChecks">
          <base-checkbox
            name="check"
            class="check"
            v-model="row.item.check"
            @input="onSelectRow($event, row.index, row.item)"
          />
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import template_lisaweb from "./template_lisaweb";
import BaseIcon from "@/components/BaseIcon";
import BaseCheckbox from "@/components/form/BaseCheckbox";
import EmptyTable from "@/components/EmptyTable.vue";

export default {
  name: "PdfTable",
  extends: template_lisaweb,
  components: {
    BaseIcon,
    EmptyTable,
    BaseCheckbox,
  },
  props: {
    performedSearch: {
      type: Boolean,
      default: false,
    },
    filterCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    isTableInModal: {
      type: Boolean,
      default: false,
    },
    saveRelationBtn: {
      type: Boolean,
      default: false,
    },
    hasChecksPaginated: {
      type: Boolean,
      default: false,
    },
    newPdfBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    freeSearch() {
      this.$emit("manualFetch");
    },
    onAddNewPdf() {
      this.$router.push({
        name: `${this.resource}.create`,
        params: {
          /* remove the / character if it is the first character of a string */
          returnUrl: this.$route.path.replace(/^\/(.*)/, "$1"),
        },
      });
    },
  }
};
</script>
<style lang="scss" scoped>
:deep(table td:nth-child(4)) {
  &,
  ~ td {
    vertical-align: top;
  }
}
</style>
